import { Reveal } from "./Reveal";
import { POSE, STRIP_SERVIZI, scrollToId } from "../lib/site";
import { Check, ArrowRight } from "lucide-react";

const Pricing = () => (
  <section
    id="prezzi"
    className="grain relative bg-walnut py-28 text-cream md:py-40"
    data-testid="pricing-section"
  >
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <p className="mb-4 font-sans text-xs font-light uppercase tracking-[0.45em] text-honey">
          Prezzi standard
        </p>
        <h2 className="max-w-2xl font-display text-4xl font-medium leading-tight sm:text-5xl lg:text-6xl">
          Tre pose, tre prezzi. <em className="text-honey">Chiari.</em>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {POSE.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.12}>
            <article
              data-testid={`pricing-card-${p.id}`}
              className={`group relative flex h-full flex-col rounded-2xl border p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-2 ${
                i === 1
                  ? "border-honey/60 bg-bark shadow-2xl shadow-black/40"
                  : "border-cream/15 bg-walnut hover:border-honey/40"
              }`}
            >
              <h3 className="font-display text-3xl font-medium">
                {p.nome}
              </h3>
              <p className="mt-2 font-sans text-sm font-light text-sand/75">
                {p.tagline}
              </p>
              <div className="mt-8 flex items-end gap-1">
                <span
                  className="font-display text-6xl font-semibold text-honey"
                  data-testid={`pricing-price-${p.id}`}
                >
                  {p.prezzo}€
                </span>
                <span className="pb-2 font-sans text-sm font-light text-sand/70">
                  / mq
                </span>
              </div>
              <p className="mt-6 flex items-start gap-2 border-t border-cream/10 pt-5 font-sans text-xs font-light leading-relaxed text-sand/70">
                <Check size={14} className="mt-0.5 shrink-0 text-honey" />
                {p.note}
              </p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          className="mt-10 flex flex-wrap items-center gap-4 rounded-2xl border border-cream/10 bg-bark/40 px-6 py-6"
          data-testid="extra-services-strip"
        >
          <span className="font-sans text-sm font-light uppercase tracking-[0.35em] text-honey">
            E non solo
          </span>
          {STRIP_SERVIZI.map((s) => (
            <span
              key={s.label}
              className="rounded-full border border-cream/25 px-5 py-2.5 font-sans text-sm font-light text-sand"
            >
              {s.label}{" "}
              <strong className="font-medium text-honey">
                da {s.prezzo}€/mq
              </strong>
            </span>
          ))}
          <span className="font-sans text-sm font-light italic text-sand/70">
            prezzi di partenza, confermati al sopralluogo
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-col items-start justify-between gap-6 rounded-2xl border border-honey/30 bg-bark/60 p-7 md:flex-row md:items-center">
          <p
            className="max-w-2xl font-sans text-sm font-light leading-relaxed text-sand/85"
            data-testid="pricing-disclaimer"
          >
            I prezzi sono indicativi e vengono{" "}
            <strong className="font-medium text-cream">
              confermati dopo il sopralluogo gratuito
            </strong>
            : casa vuota o arredata, porte da adattare e dislivelli del
            sottofondo possono far variare il preventivo.
          </p>
          <button
            onClick={() => scrollToId("calcolatore")}
            data-testid="pricing-cta-calcolatore"
            className="group flex shrink-0 items-center gap-2 rounded-full bg-honey px-6 py-3 font-sans text-sm font-medium text-ink transition-colors duration-300 hover:bg-cream"
          >
            Calcola il tuo prezzo
            <ArrowRight
              size={15}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
